/*
 * @Author: 豆豆
 * @LastEditors: gxd
 * @Date: 2020-10-31 17:09:22
 * @LastEditTime: 2020-12-29 15:14:25
 * @Description: File description
 */
/**
 * @description: 根据不同海报类型，确定不同的海报数据结构
 * type:
 * 1. 普通海报，仅背景和二维码
 * 2. 包含二维码、顶部头像和昵称
 * 3、4. 包含二维码、底部头像和昵称
 * @return {*}
 * @author: gxd
 */
const posterDetails = (type, data) => {
  const qrCode = (data.isQrCode === 1) ? data.qrCode : `${data.qrCode}?x-oss-process=image/resize,p_60`
  // const qrCode = `${data.qrCode}?x-oss-process=image/resize,h_200,m_lfit`
  // if (qrCode.indexOf('oss') < 0) {
  //   qrCode = qrCode.replace(/^http(s)?:\/\/(.*?)\//, 'https://activity.xueersi.com/oss2/')
  // }
  switch (type) {
    case 1:
      return [{
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: data.bgImg,
        type: 'bgImg'
      }, {
        x: 535,
        y: 990,
        width: 150,
        height: 150,
        url: qrCode,
        type: 'qrCode'
      }]
    case 2:
      return [{
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: data.bgImg,
        type: 'bgImg'
      }, {
        x: 535,
        y: 990,
        width: 150,
        height: 150,
        url: qrCode,
        type: 'qrCode'
      }, {
        x: 325,
        y: 140,
        width: 100,
        height: 100,
        isAvatar: true,
        url: `${data.avatar}?allow_3xx=0&pipeline=size,w_50`,
        type: 'avatar'
      }, {
        x: 375,
        y: 270,
        width: 200,
        height: 30,
        lineNumber: 1,
        lineHeight: 30,
        text: data.nick ? data.nick : '超级学霸',
        textAlign: 'center',
        font: 'bold 32px Tahoma'
      }]
    case 3:
      return [{
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: data.bgImg,
        type: 'bgImg'
      }, {
        x: 535,
        y: 990,
        width: 150,
        height: 150,
        url: qrCode,
        type: 'qrCode'
      }, {
        x: 325,
        y: 697,
        width: 100,
        height: 100,
        isAvatar: true,
        url: `${data.avatar}?allow_3xx=0&pipeline=size,w_50`,
        type: 'avatar'
      }, {
        x: 377,
        y: 807,
        width: 200,
        height: 30,
        lineNumber: 1,
        lineHeight: 30,
        text: data.nick ? data.nick : '超级学霸',
        textAlign: 'center',
        textColor: '#ffffff',
        font: 'bold 32px Tahoma'
      }]
    case 4: // 头像、昵称、两条学习数据
      return [{
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: data.bgImg,
        type: 'bgImg'
      }, {
        x: 534,
        y: 990,
        width: 150,
        height: 150,
        url: qrCode,
        type: 'qrCode'
      }, {
        x: 49,
        y: 679,
        width: 87,
        height: 87,
        isAvatar: true,
        url: `${data.avatar}?allow_3xx=0&pipeline=size,w_50`,
        type: 'avatar'
      }, {
        x: 149,
        y: 705,
        width: 200,
        height: 30,
        lineNumber: 1,
        lineHeight: 30,
        text: data.nick ? data.nick : '超级学霸',
        textAlign: 'left',
        textColor: '#333333',
        font: 'bold 36px Tahoma'
      }, {
        x: 510,
        y: 776,
        width: 200,
        height: 40,
        lineNumber: 1,
        lineHeight: 40,
        text: data.studyDays,
        textAlign: 'right',
        textColor: '#FFEB8B',
        font: 'bold 40px Tahoma'
      }, {
        x: 510,
        y: 828,
        width: 200,
        height: 40,
        lineNumber: 1,
        lineHeight: 40,
        text: data.answerCount,
        textAlign: 'right',
        textColor: '#FFEB8B',
        font: 'bold 40px Tahoma'
      }]
    case 5: // 头像、昵称、三条学习数据
      return [{
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: data.bgImg,
        type: 'bgImg'
      }, {
        x: 534,
        y: 981,
        width: 150,
        height: 150,
        url: qrCode,
        type: 'qrCode'
      }, {
        x: 88,
        y: 166,
        width: 82,
        height: 82,
        isAvatar: true,
        url: `${data.avatar}?allow_3xx=0&pipeline=size,w_50`,
        type: 'avatar'
      }, {
        x: 191,
        y: 175,
        width: 200,
        height: 30,
        lineNumber: 1,
        lineHeight: 30,
        text: data.nick ? data.nick : '超级学霸',
        textAlign: 'left',
        textColor: '#333333',
        font: 'bold 26px Tahoma'
      }, {
        x: 150,
        y: 295,
        width: 160,
        height: 60,
        lineNumber: 1,
        lineHeight: 60,
        text: data.studyDays,
        textAlign: 'center',
        textColor: '#333333',
        font: '900 60px Tahoma'
      }, {
        x: 375,
        y: 295,
        width: 160,
        height: 60,
        lineNumber: 1,
        lineHeight: 60,
        text: data.answerCount,
        textAlign: 'center',
        textColor: '#333333',
        font: '900 60px Tahoma'
      }, {
        x: 590,
        y: 295,
        width: 160,
        height: 60,
        lineNumber: 1,
        lineHeight: 60,
        text: data.rightRate,
        textAlign: 'center',
        textColor: '#333333',
        font: '900 60px Tahoma'
      }]
    case 6: // 头像、昵称、两条学习数据
      return [{
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: data.bgImg,
        type: 'bgImg'
      }, {
        x: 534,
        y: 990,
        width: 150,
        height: 150,
        url: qrCode,
        type: 'qrCode'
      }, {
        x: 88,
        y: 166,
        width: 82,
        height: 82,
        isAvatar: true,
        url: `${data.avatar}?allow_3xx=0&pipeline=size,w_50`,
        type: 'avatar'
      }, {
        x: 191,
        y: 175,
        width: 200,
        height: 30,
        lineNumber: 1,
        lineHeight: 30,
        text: data.nick ? data.nick : '超级学霸',
        textAlign: 'left',
        textColor: '#333333',
        font: 'bold 26px Tahoma'
      }, {
        x: 190,
        y: 285,
        width: 160,
        height: 60,
        lineNumber: 1,
        lineHeight: 60,
        text: data.studyDays,
        textAlign: 'center',
        textColor: '#333333',
        font: '900 60px Tahoma'
      }, {
        x: 510,
        y: 285,
        width: 160,
        height: 60,
        lineNumber: 1,
        lineHeight: 60,
        text: data.answerCount,
        textAlign: 'center',
        textColor: '#333333',
        font: '900 60px Tahoma'
      }]
    default:
      return false
  }
}
export default posterDetails
